export const GIFT_SELECTION_TEST_ID = {
    GIFT_PREVIEW_BUTTON: 'gift-preview-button',
    GIFT_PREVIEW_MODAL: 'gift-preview-modal',
    GIFT_SELECTION_MODAL: 'gift-selection-modal',
    PRICE: 'gift-modal-price',
    OLD_PRICE: 'gift-modal-old-price',
};
